/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Dataroom_Uploadstatus_Error3Inputs */

const en_coinvestments_dataroom_uploadstatus_error3 = /** @type {(inputs: Coinvestments_Dataroom_Uploadstatus_Error3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upload failed`)
};

/**
* | output |
* | --- |
* | "Upload failed" |
*
* @param {Coinvestments_Dataroom_Uploadstatus_Error3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_dataroom_uploadstatus_error3 = /** @type {((inputs?: Coinvestments_Dataroom_Uploadstatus_Error3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Dataroom_Uploadstatus_Error3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_dataroom_uploadstatus_error3(inputs)
});
export { coinvestments_dataroom_uploadstatus_error3 as "coInvestments_dataRoom_uploadStatus_error" }